export const DATE_FORMAT = 'ddd, D MMM';
